import React from 'react'
import './CustomMessage.sass'

const CustomMessage = ({ message }) => {
  return <span className='no-books-custom-message'>{message}</span>
}

export default CustomMessage
